import {messagesService} from "@dv5/api"
import {AddSubTaskMessage, ChangeTaskStatusMessage, GetTaskMessage} from '../types'

class TaskApi {
    getTask(id: string, layers: string[], tags: string[]): void {
        messagesService.send<GetTaskMessage>('tasks.get-task', { documentId: id, layers: layers.join(','), tags: tags.join(',') })
    }

    addSubTask(payload: AddSubTaskMessage): void {
        messagesService.send<AddSubTaskMessage>('tasks.add-sub-task', payload)
    }

    changeStatus(id: string, status: string): void {
        messagesService.send<ChangeTaskStatusMessage>('tasks.change-status', { taskId: id, status })
    }
}

export const taskApi = new TaskApi()
